export function handleConcatStrings(...args: string[]) {
  return args.join('!')
}
